import { connect } from "react-redux";
import L from "leaflet";
import "leaflet-easybutton/src/easy-button.css";
import { mapActions } from "../../../../store/actions";
import { RecentIncidents, AllIncidents } from "../../../../utils/imageSource";

function IncidentControl(props) {
  const mapInstance = props.map;
  const { todayIncident } = props;
  // console.log("gnk-1")

  let label =
    todayIncident === false
      ? "View all spot reports"
      : "View today’s spot reports";
  let icon = todayIncident === false ? RecentIncidents : AllIncidents;
  let iconFont = todayIncident === false ? "fa-map-marker" : "fa-globe";
  let iconImage =
    '<img class="zoom-in zoom-btn remove-recent-btn" src="' +
    icon +
    '" alt="' +
    label +
    '"/>';
  let image = document.documentElement.clientWidth > 600 ? iconImage : iconFont;

  var toggle = L.easyButton({
    position: "topleft", // topleft, topright, bottomleft, bottomright
    states: [
      {
        stateName: "remove-recent-incidents",
        icon: image,
        title: label,
        onClick: function (control) {
          if (todayIncident === false) {
            props.loadMapTodaysData();
            
            // setTimeout(function() {
              // props.setZoomLevel([26.3351,17.2283]);
            // }, 1000);
            control.state("add-recent-incidents");
          } else {
            props.loadMapData();
            control.state("remove-recent-incidents");
          }
        },
      },
      {
        icon: "fa-search-plus",
        stateName: "add-recent-incidents",
        onClick: function (control) {
          props.loadMapData();
          control.state("remove-recent-incidents");
        },
        title: "View all spot reports",
      },
    ],
  });
  toggle.addTo(mapInstance);
  return null;
}

function mapStateToProps(state) {
  const { todayIncident } = state.map;
  return { todayIncident };
}

const mapDispatchToProps = {
  loadMapData: mapActions.loadMapData,
  loadMapTodaysData: mapActions.loadMapTodaysData,
  // setZoomLevel: mapActions.setZoomLevel
};

export default connect(mapStateToProps, mapDispatchToProps)(IncidentControl);
